// Test IDs for the VegUK landing page

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkTypes: "nav-link-types",
  linkExceptions: "nav-link-exceptions",
  linkPrep: "nav-link-prep",
  linkContact: "nav-link-contact",
};

export const HERO = {
  root: "hero-root",
  ctaTypes: "hero-cta-types",
  ctaContact: "hero-cta-contact",
};

export const ABOUT = {
  root: "about-root",
  objective: (idx) => `about-objective-${idx}`,
};

export const TYPES = {
  root: "types-root",
  card: (code) => `type-card-${code}`,
};

export const EXCEPTIONS = {
  root: "exceptions-root",
};

export const PREP = {
  root: "prep-root",
  item: (idx) => `prep-item-${idx}`,
};

export const CONTACT = {
  root: "contact-root",
  formName: "contact-input-name",
  formEmail: "contact-input-email",
  formOrg: "contact-input-organisation",
  formMessage: "contact-input-message",
  formSubmit: "contact-submit-btn",
  newsletterEmail: "newsletter-input-email",
  newsletterSubmit: "newsletter-submit-btn",
};

export const FOOTER = {
  root: "footer-root",
};
